import React from "react";

export default function InstallmentSkeleton() {
  return (
    <div className="min-h-screen bg-[#f8f9ff] pt-6 pb-12 antialiased animate-pulse">
      <div className="max-w-3xl mx-auto px-4 md:mt-8 space-y-6">
        <div className="flex items-center justify-between p-4">
          <div className="w-8 h-8 bg-gray-200 rounded-full"></div>
          <div className="h-5 bg-gray-200 rounded w-48 mx-auto"></div>
          <div className="w-8 h-8 bg-gray-200 rounded-full"></div>
        </div>

        <div className="bg-white rounded-2xl p-5 border border-gray-100 h-[190px] flex flex-col justify-between">
          <div>
            <div className="h-4 bg-gray-200 rounded w-16 mb-2"></div>
            <div className="flex justify-between items-baseline">
              <div className="h-6 bg-gray-200 rounded w-28"></div>
              <div className="h-7 bg-gray-200 rounded w-12"></div>
            </div>
            <div className="h-2.5 bg-gray-200 rounded w-full mt-3"></div>
          </div>

          <div className="border-t border-gray-100 my-2"></div>

          <div className="grid grid-cols-2 gap-2">
            <div className="space-y-1.5 flex flex-col items-center">
              <div className="h-3 bg-gray-200 rounded w-20"></div>
              <div className="h-5 bg-gray-200 rounded w-24"></div>
            </div>
            <div className="space-y-1.5 flex flex-col items-center">
              <div className="h-3 bg-gray-200 rounded w-24"></div>
              <div className="h-5 bg-gray-200 rounded w-20"></div>
            </div>
          </div>
        </div>

        <div className="space-y-3">
          <div className="h-5 bg-gray-200 rounded w-32 mb-4 px-1"></div>

          <div className="bg-white rounded-xl p-4 border border-gray-100 h-[82px] flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 bg-gray-200 rounded-full"></div>
              <div className="space-y-2">
                <div className="h-4 bg-gray-200 rounded w-20"></div>
                <div className="h-3 bg-gray-200 rounded w-24"></div>
              </div>
            </div>
            <div className="space-y-2 flex flex-col items-end">
              <div className="h-5 bg-gray-200 rounded w-16"></div>
              <div className="h-3 bg-gray-200 rounded w-12"></div>
            </div>
          </div>

          <div className="bg-white rounded-xl border border-gray-100 h-[138px] flex flex-col justify-between p-4">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-gray-200 rounded-full"></div>
                <div className="space-y-2">
                  <div className="h-4 bg-gray-200 rounded w-20"></div>
                  <div className="h-3 bg-gray-200 rounded w-24"></div>
                </div>
              </div>
              <div className="space-y-2 flex flex-col items-end">
                <div className="h-5 bg-gray-200 rounded w-16"></div>
                <div className="h-3 bg-gray-200 rounded w-24"></div>
              </div>
            </div>
            <div className="h-[38px] bg-gray-200 rounded-xl w-full"></div>
          </div>

          <div className="bg-white/70 rounded-xl p-4 border border-gray-100 h-[82px] flex items-center justify-between opacity-60">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 bg-gray-200 rounded-full"></div>
              <div className="space-y-2">
                <div className="h-4 bg-gray-200 rounded w-20"></div>
                <div className="h-3 bg-gray-200 rounded w-24"></div>
              </div>
            </div>
            <div className="space-y-2 flex flex-col items-end">
              <div className="h-5 bg-gray-200 rounded w-16"></div>
              <div className="h-3 bg-gray-200 rounded w-12"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
